export default {
    name: 'Contributor',

    props: {
        operation: {
            type: Object,
            required: true
        }
    },

    methods: {
        /**
         * Get contributor full name
         * @return {String} contributor full name
         */
        getContributorFullName() {
            return `${this.operation.contributor.name} ${this.operation.contributor.lastname_1} ${this.operation.contributor.lastname_2 || ''}`;
        }
    }
};
